
import { useState, type FormEvent } from 'react';
import Button from './ui/Button';

interface LoginModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLogin: (client?: any) => void;
  t: {
    title: string;
    subtitle: string;
    emailPlaceholder: string;
    passwordPlaceholder: string;
    loginButton: string;
    termsPrefix: string;
    termsNDA: string;
    termsAnd: string;
    termsService: string;
    loginError: string;
  }
}

const LoginModal = ({ isOpen, onClose, onLogin, t }: LoginModalProps) => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleLogin = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    const formData = new FormData(e.currentTarget);
    const email = formData.get('email') as string;
    const password = formData.get('password') as string;

    // 1. Check Master Admin Login (Hardcoded as requested before or as fallback)
    if (email === 'admin@negolan.com' && password === 'Negolan2024!') {
      setLoading(false);
      onLogin(); // Admin login
      return;
    }

    if (email === 'investor@negolan.com' && password === 'prueba69%') {
      setLoading(false);
      onLogin(); 
      return;
    }

    // 2. Check Cloudflare D1 Clients
    try {
      const response = await fetch('/api/admin/clients/verify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        onLogin(data.client);
      } else {
        setError(t.loginError);
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Error de conexión con el servidor de autenticación');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setError('');
    onClose();
  }

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={handleClose}>
      <div 
        className="bg-slate-800 border border-slate-700 rounded-2xl shadow-2xl w-full max-w-md relative"
        onClick={e => e.stopPropagation()}
      >
        <button onClick={handleClose} className="absolute top-4 right-4 text-slate-400 hover:text-white">
          &times;
        </button>

        <div className="p-8">
            <h2 className="text-2xl font-bold text-white text-center mb-2">{t.title}</h2>
            <p className="text-slate-400 text-center mb-6">{t.subtitle}</p>
          
            <form onSubmit={handleLogin}>
                <div className="space-y-4">
                    <input type="email" name="email" placeholder={t.emailPlaceholder} required className="w-full bg-slate-700 text-white p-3 rounded-lg border border-slate-600 focus:ring-2 focus:ring-blue-500 focus:outline-none" />
                    <input type="password" name="password" placeholder={t.passwordPlaceholder} required className="w-full bg-slate-700 text-white p-3 rounded-lg border border-slate-600 focus:ring-2 focus:ring-blue-500 focus:outline-none"/>
                </div>
                
                {error && (
                  <div className="mt-4 p-3 bg-red-500/20 border border-red-500/50 rounded-lg text-red-200 text-sm font-medium text-center">
                    {error}
                  </div>
                )}

                <div className="mt-6">
                    <Button type="submit" variant="primary" className="w-full" disabled={loading}>
                        {loading ? 'Accediendo...' : t.loginButton}
                    </Button>
                </div>
                <div className="mt-4 text-xs text-slate-500 text-center">
                    <p>{t.termsPrefix} <a href="#" className="underline hover:text-slate-300">{t.termsNDA}</a> {t.termsAnd} <a href="#" className="underline hover:text-slate-300">{t.termsService}</a>.</p>
                </div>
            </form>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
